<template>
  <div class="_header" :style="`background-color:${backgroundColor}`">
    <div
      class="left"
      :style="`background-image: url('${dark ? darkIcon : brightIcon}')`"
      @click="navigateTo"
    ></div>
    <h1
      :style="
        `color: ${titleColor ? titleColor : dark ? darkColor : brightColor}`
      "
    >
      {{ title }}
    </h1>
    <div class="right">
      <slot />
    </div>
  </div>
</template>

<script>
import brightIcon from "@/assets/vip/back@2x.png";
import darkIcon from "@/assets/vip/back_black@2x.png";
import router from "@/router";

export default {
  name: "MlHeader",
  props: {
    title: {
      type: String,
      default: ""
    },
    titleColor: {
      type: String,
      default: null
    },
    dark: {
      type: Boolean,
      default: false
    },
    backgroundColor: {
      type: String,
      default: "transparent"
    },
    navigateTo: {
      type: Function,
      default: function() {
        router.back();
      }
    }
  },
  data() {
    return {
      brightIcon,
      darkIcon,
      brightColor: "#fff",
      darkColor: "rgba(33, 40, 50, 1)"
    };
  },
  methods: {
    goBack() {
      this.$router.back();
    }
  }
};
</script>

<style lang="scss" scoped>
._header {
  position: fixed;
  top: 0;
  height: 40px;
  width: 100%;
  overflow: hidden;
  z-index: 999;
  .left {
    position: absolute;
    left: 0;
    width: 40px;
    height: 40px;
    background-size: 9px 14px;
    background-position: center;
    background-repeat: no-repeat;
  }
  h1 {
    font-size: 16px;
    font-weight: 500;
    line-height: 40px;
  }
  .right {
    position: absolute;
    top: 0;
    right: 0;
    box-sizing: content-box;
    height: 40px;
    text-align: right;
    > p {
      white-space: nowrap;
      line-height: 40px;
      padding-right: 15px;
    }
  }
}
</style>
